import { render, staticRenderFns } from "./FormContactExpoVivienda.vue?vue&type=template&id=d0120be2&scoped=true&"
import script from "./FormContactExpoVivienda.vue?vue&type=script&lang=js&"
export * from "./FormContactExpoVivienda.vue?vue&type=script&lang=js&"
import style0 from "./FormContactExpoVivienda.vue?vue&type=style&index=0&id=d0120be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0120be2",
  null
  
)

export default component.exports